import { DOMAIN } from '../env'

export const getIsOldFrontUrl = (): boolean => {
  const domainParts = window.location.hostname.split('.')
  return domainParts[0] !== DOMAIN.split('.')[0]
}
